import QRCode from 'qrcode';
import { useEffect, useState } from 'react';

const QR_CODE_OPTIONS = {
  errorCorrectionLevel: 'M',
  margin: 2,
  width: 200,
} as const;

export const useQrCode = (data: string | null) => {
  const [dataUrl, setDataUrl] = useState<string | null>(null);
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let isActive = true;
    setError(false);
    setDataUrl(null);

    if (!data) {
      setIsLoading(false);
      return () => {
        isActive = false;
      };
    }

    setIsLoading(true);

    QRCode.toDataURL(data, QR_CODE_OPTIONS)
      .then((url) => {
        if (isActive) {
          setDataUrl(url);
          setIsLoading(false);
        }
      })
      .catch(() => {
        if (isActive) {
          setError(true);
          setIsLoading(false);
        }
      });

    return () => {
      isActive = false;
    };
  }, [data]);

  return { dataUrl, error, isLoading };
};
